// Common
import moment from 'moment';
import ReactDOM from 'react-dom';
import { updateUrl } from '../../filter_utils';
import FooterAdGoogle from '../ad/desktop/footer_ad_google.js.jsx';
import FooterAdYandex from '../ad/desktop/footer_ad_yandex.js';
import FilterMain from '../filter_main.js.jsx';
import FilterProgressBar from '../filter_progress_bar.js';
import FilterTagsList from '../filter_tags_list.js';
import MapDesktop from '../map_desktop.js.jsx';
import CampList from './camp_list.js.jsx';
import CampListLoading from './camp_list_loading.js.jsx';
import FilterAside from './filter_aside.js.jsx';
import FilterHeader from './filter_header.js.jsx';
import { syncSearchWidgetData } from './lib/sync_search_widget_data';
import { SearchDataPopup } from './ui/search_data_popup';

export default class FilterDesktop extends FilterMain {
  constructor(props) {
    super(props);
    this.handleSubmitSearchDataPopup = this.handleSubmitSearchDataPopup.bind(this);
    this.filterAsideClassName = this.filterAsideClassName.bind(this);
    this.setDescending = this.setDescending.bind(this);
    this.emptyOutput = this.emptyOutput.bind(this);
    this.errorOutput = this.errorOutput.bind(this);

    this.onInitialLoadingFinished = this.onInitialLoadingFinished.bind(this);
    this.progressBar = null;
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener('popstate', (e) => {
      this.handlePopstate();
    });
    this.get_user_show_filter();

    const seoPopularPlacesHidden = document.getElementById('seo-popular-places-hidden');
    if (seoPopularPlacesHidden) {
      const block = seoPopularPlacesHidden.firstElementChild;
      if (block) {
        const target = document.querySelector('.col-9 .founded-camps');

        if (target && target.parentNode) {
          target.parentNode.insertBefore(block, target);
        }
      }
    }
  }

  /**
   * @param {string} dateStart
   * @param {string} dateEnd
   * @param {number} countGuests
   * @param {Array<number>} childrenAges
   * @param {boolean} withPet
   */
  handleSubmitSearchDataPopup(dateStart, dateEnd, countGuests, childrenAges, withPet) {
    const parsedDateStart = moment(dateStart, 'DD-MM-YYYY');
    const parsedDateEnd = moment(dateEnd, 'DD-MM-YYYY');
    const deltaDays =
      parsedDateStart.isValid() && parsedDateEnd.isValid() ? parsedDateEnd.diff(parsedDateStart, 'days') : null;

    this.setState(
      (state) => {
        const newState = {
          s_params: {
            ...state.s_params,
            date_start: dateStart,
            date_end: dateEnd,
            count_guests: countGuests,
            children_ages: childrenAges,
            with_pet: withPet,
          },
          datesChosen: dateStart != null || dateEnd != null,
        };
        if (deltaDays != null) newState.s_params.delta_days = deltaDays;
        return newState;
      },
      () => {
        if (!this.state.listShowMode) {
          this.setState({ pendingLoadCamps: true });
        } else {
          this.loadCamps(0);
        }

        updateUrl(
          this.state.filters,
          this.state.pageNum,
          this.state.listShowMode,
          this.state.s_params,
          this.state.sort,
          this.descending,
          this.seoMapOpened
        );
        syncSearchWidgetData(dateStart, dateEnd, countGuests, childrenAges, withPet);
      }
    );
  }

  setDescending(type, allowReverse) {
    this.descending = allowReverse;
  }

  filterAsideClassName() {
    let className = 'aside';
    if (this.state.mapCampsLoaded && !this.state.listShowMode) className += ' aside-fixed';
    if (this.state.showingInitialCamps) className += ' card-loader disabling-loader';
    return className;
  }

  emptyOutput(price_max_end) {
    return (
      <div className='search-none'>
        <div className='search-none__grid'>
          <div className='icon search-icon_img'></div>
          <div>
            <h5>К сожалению, под ваши критерии не найден ни один вариант размещения.</h5>
            <p className='search-none__grid__text text_gray'>Облегчите параметры поиска или сбросьте его</p>
          </div>
        </div>
      </div>
    );
  }

  errorOutput() {
    return (
      <div className='search-none'>
        <div className='search-none__grid'>
          <div className='icon search-icon_img'></div>
          <div>
            <h5>Произошла ошибка.</h5>
            <p className='search-none__grid__text text_gray'>
              Попробуйте обновить страницу, либо измените параметры поиска
            </p>
          </div>
        </div>
      </div>
    );
  }

  get_user_show_filter() {
    fetch(`${window.website_prefix}/helpers/our_stuff`)
      .then((response) => response.json())
      .then((data) => {
        this.setState({ user_show_filter: data.our_stuff });
      });
  }

  onInitialLoadingFinished() {
    if (this.progressBar) {
      this.progressBar.finishLoading(() => {
        this.setState({
          isInitialLoading: false,
        });
      });
    } else {
      this.setState({
        isInitialLoading: false,
      });
    }
  }

  render() {
    const price_max_end = this.priceMaxEnd();

    let map;
    if (!this.state.listShowMode) {
      map = <MapDesktop {...this.mapProps()} showManagerMap={this.state.s_params.our_stuff} />;
    }

    let campList;

    if (this.state.campsLoaded) {
      if (this.state.camps.length > 0) {
        campList = (
          <div>
            <CampList
              camps={this.state.camps}
              showMapCamp={this.showMap}
              showContractPercent={this.state.s_params.our_stuff}
              showCommission={this.state.s_params.our_stuff}
              river={this.props.river}
              region_work_with={this.props.region_work_with}
              display_calculated_price={this.props.region_work_with || this.props.river_contracted_camp_exist}
              filter_params={this.props.filter_params}
              show_ads={this.props.filter_params.show_ads}
              show_transfer={this.props.show_transfer_block}
              count_guests={this.state.s_params.count_guests}
              children_ages={this.state.s_params.children_ages}
              fewerCountGuests={this.fewerCountGuests}
              delta_days={this.state.s_params.delta_days}
              filters={this.state.filters}
              campsLoaded={this.state.campsLoaded}
              showingInitialCamps={this.state.showingInitialCamps}
              style={{ display: this.state.listShowMode ? 'block' : 'none' }}
              filter_values={this.props.filter_values}
              favorites={this.state.favorites}
              toggleFavoriteCamp={this.toggleFavoriteCamp}
              nearbyCamps={this.state.nearbyCamps}
              nearbyLoading={this.state.nearbyLoading}
              nearbyLastPageLoaded={this.state.nearbyLastPageLoaded}
              loadMore={this.loadMore}
            />
            {!this.state.campsLoadingMore && !this.state.lastPageLoaded && (
              <div className={'pagination__item'} onClick={() => this.loadMore()}>
                Показать еще
              </div>
            )}
          </div>
        );
      } else if (this.state.loadError && this.state.allChunksLoaded) {
        campList = this.errorOutput();
      } else if (!this.state.campsLoadingMore && this.state.allChunksLoaded) {
        campList = this.emptyOutput(price_max_end);
      } else {
        campList = <CampListLoading camps_count={this.pageSize} />;
      }
    } else if (
      !this.state.campsLoaded &&
      this.state.listShowMode &&
      !this.campsLoadingError &&
      this.state.showListLoading
    ) {
      campList = <CampListLoading camps_count={this.pageSize} />;
    }

    let filterOutput;
    if (this.state.campsLoaded && this.state.campsLoadingMore) {
      filterOutput = (
        <div>
          {campList}
          <div style={{ marginBottom: 22 }} />
          <CampListLoading camps_count={5} />
          {map}
        </div>
      );
    } else if (!this.state.campsLoaded && this.campsLoadingError) {
      filterOutput = <div className='text_center'>При загрузке ОР произошла ошибка</div>;
    } else {
      filterOutput = (
        <div>
          {campList}
          {map}
        </div>
      );
    }

    const loader = this.state.isInitialLoading && this.state.listShowMode && !this.campsLoadingError && (
      <FilterProgressBar
        ref={(el) => {
          this.progressBar = el;
        }}
      />
    );

    const showAds = (
      <div className='row'>
        <FooterAdYandex
          show_ads={this.props.filter_params.show_ads}
          number_of_camps={this.state.camps.length}
          camps_required={this.numberOfCampsRequiredToShowFooterAds}
        />
        <FooterAdGoogle show_ads={this.props.filter_params.show_ads} />
      </div>
    );

    const adsPlaceholder = document.getElementById('ads-placeholder');
    const total_guests_count = this.state.s_params.count_guests + this.state.s_params.children_ages.length;

    return (
      <div className='container'>
        {loader}
        <div className='row' id='filter_content'>
          <div className='col-3'>
            <div className={this.filterAsideClassName()}>
              <FilterAside
                price_max_end={price_max_end}
                filter={this.filter}
                filters_counts={
                  this.state.listShowMode
                    ? (this.state.html_params?.filters_counts ?? {})
                    : (this.state.map_html_params?.filters_counts ?? {})
                }
                data={this.props.filter_params}
                filters={this.state.filters}
                datesChosen={this.state.datesChosen}
                initPrices={this.state.initPrices}
                count_guests={this.state.s_params.count_guests}
                total_guests_count={total_guests_count}
                campsLoaded={this.state.campsLoaded && !this.state.showingInitialCamps}
                camps={this.state.camps}
                distanceInteraction={this.distanceInteraction}
                distanceToSkiLiftInteraction={this.distanceToSkiLiftInteraction}
                is_foreign={this.props.is_foreign}
                displaySkiLiftRange={this.props.displaySkiLiftRange}
                showManagerMap={this.state.s_params.our_stuff}
                listShowMode={this.state.listShowMode}
                filter_values={this.props.filter_values}
                user_show_filter={this.state.user_show_filter}
                mirturbaz={this.props.mirturbaz}
                ubook={this.props.ubook}
              />
            </div>
          </div>

          <div className='col-9'>
            <div className='founded-camps'>
              <FilterTagsList
                price_max_end={this.priceMaxEnd()}
                filters={this.state.filters}
                data={this.props.filter_params}
                filter={this.filter}
                campsLoaded={this.state.campsLoaded && !this.state.showingInitialCamps}
                resetFilter={this.resetFilter}
                is_desktop
                camps={this.state.camps}
                user_show_filter={this.state.user_show_filter}
              />
              <FilterHeader
                url_str={this.props.filter_params.url_str}
                region={this.props.filter_params.region}
                city={this.props.filter_params.city}
                river={this.props.river}
                region_work_with={this.props.region_work_with}
                sort={this.sort}
                sort_type={this.state.sort}
                descending={this.descending}
                total={this.state.camps.length}
                pageNum={this.state.pageNum}
                pageSize={this.pageSize}
                showMap={this.showMap}
                showList={this.showList}
                listShowMode={this.state.listShowMode}
                show_ads={this.props.filter_params.show_ads}
                campsLoaded={this.state.campsLoaded && !this.state.showingInitialCamps}
              />

              {filterOutput}

              <div id='loading-map' className='loading-map hidden'>
                <div className='load-icon loading__img loading-map__img'></div>
                Загрузка...
              </div>
            </div>
          </div>
        </div>

        {adsPlaceholder && ReactDOM.createPortal(showAds, adsPlaceholder)}
        {this.seoMapOpened && (
          <SearchDataPopup
            title={this.props.seo_h1}
            mapOpened={!this.state.listShowMode}
            onSubmit={this.handleSubmitSearchDataPopup}
          />
        )}
      </div>
    );
  }
}
